import {VillageSurrounding} from '@/services/types';
import MediaFilterImage from '@/components/Media/MediaFilterImage';
import {ISurroundingsMapDictionary} from '@/dictionaries/components/surroundingsMap/types';

export type InfoWindowContent = {
  distance: number;
  travelTime: number;
  travelMode: string;
};

type Props = {
  dict: ISurroundingsMapDictionary;
  surrounding: VillageSurrounding;
};

export default function SurroundingsMapInfoWindowContent({
  surrounding,
  dict,
}: Props) {
  const {
    surrounding: surroundingObj,
    distance,
    travelMode,
    travelTime,
  } = surrounding;

  const {image, translate} = surroundingObj;
  const surroundingTranslate = translate[0] || '';

  function getKmAndMilesString() {
    if (distance) {
      const miles = distance * 0.621371;
      const roundedMiles = (miles / 1000).toFixed(1);
      const roundedKms = (distance / 1000).toFixed(1);
      return `${roundedKms} km / ${roundedMiles} ${dict.miles}`;
    }

    return `0 km / 0 ${dict.miles}`;
  }

  function getTravelTimeAndModeString() {
    let travelModeTranslation = '';

    if (dict.travelMode[travelMode]) {
      travelModeTranslation = dict.travelMode[travelMode];
    }

    if (travelTime >= 60) {
      const hours = Math.floor(travelTime / 60);
      const minutes = travelTime % 60;
      let hoursString = '';
      let minuteString = '';

      if (hours > 1) {
        hoursString = `${hours} ${dict.hours},`;
      }
      if (hours === 1) {
        hoursString = `${hours} ${dict.hour},`;
      }
      if (minutes > 0) {
        minuteString = `${minutes} ${dict.minutes}`;
      }

      const timeString = `${hoursString} ${minuteString}`;
      return `${timeString} ${travelModeTranslation}`;
    } else {
      return `${travelTime} ${dict.minutes} ${travelModeTranslation}`;
    }
  }

  return (
    <div className="flex text-graphite">
      <MediaFilterImage
        media={image}
        filterName="small_1-1"
        className="hidden md:block w-[109px] h-[109px] shrink-0"
        alt="Surrouding Image"
        width={109}
        height={109}
      />
      <div className="p-[5px] flex flex-col justify-between gap-2 text-sm font-normal">
        <span className="text-base">{surroundingTranslate.title}</span>
        <span>{getKmAndMilesString()}</span>
        <span>{getTravelTimeAndModeString()}</span>
      </div>
    </div>
  );
}
